import React from 'react'
import { Link } from 'react-router-dom'
import img11 from './images/amzon.png'
import img12 from './images/Glowroad.png'
import img13 from './images/meesho.webp'
import img14 from './images/flipkart.webp'
import img15 from './images/shopify.png'
import img16 from './images/jio.webp'
import img17 from './images/shopsy.png'
import img18 from './images/bigbasket.png'
import img19 from './images/blinkit.webp'
import img20 from './images/myntra.webp'
import img21 from './images/nykaa.png'
import img22 from './images/tata.png'
import img23 from './images/purple.png'
import img24 from './images/paytmmall.webp'
import img25 from './images/limeroad.png'
import img101 from './images/ags.webp'
import img26 from './images/ali.png'
import img27 from './images/etsy.webp'
import img28 from './images/walmart.png'
import img29 from './images/ebay.png'
import img30 from './images/sales.png'


export default function Brand() {
  return (

    <div className='container'>
      <div className="bg-dark text-light py-3 mt-1 text-center">
        <div className="container text-center ">
          <h3 className=' text-center'> Our Comprehensive Services </h3>
          <div className="row">
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img11} width={100} height={100} alt='Queryimg' />
              <p><b>Amazon Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/domestic-services/amazon-account-management" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img12} width={100} height={100} alt='Queryimg' />
              <p><b>Glow Road Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/domestic-services/glow-road" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img13} width={100} height={100} alt='Queryimg' />
              <p><b>Meesho Account Management <br />Services</b><br />
                <button type="button" className="btn "><Link to="/domestic-services/meesho-account-management" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img14} width={100} height={100} alt='Queryimg' />
              <p><b>Flipkart Account Management <br />Services</b><br />
                <button type="button" className="btn "><Link to="/domestic-services/flipkart-account-management" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img15} width={100} height={100} alt='Queryimg' />
              <p><b>Shopify Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img16} width={100} height={100} alt='Queryimg' />
              <p><b>Jio Mart Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/domestic-services/jiomart-account" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img17} width={100} height={100} alt='Queryimg' />
              <p><b>Shopsy Account Management <br />Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img18} width={100} height={100} alt='Queryimg' />
              <p><b>Big Basket Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img19} width={100} height={100} alt='Queryimg' />
              <p><b>Blinkit Account Management <br />Services</b><br />

                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img20} width={100} height={100} alt='Queryimg' />
              <p><b>Myntra Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img21} width={100} height={100} alt='Queryimg' />
              <p><b>Nykaa Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img22} width={100} height={100} alt='Queryimg' />
              <p><b>Tata Cliq Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
          </div>
          <div className='row'>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img23} width={100} height={100} alt='Queryimg' />
              <p><b>Purple Account Management <br />Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img24} width={100} height={100} alt='Queryimg' />
              <p><b>Paytm Mall Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img25} width={100} height={100} alt='Queryimg' />
              <p><b>Lime Road Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
          </div>
        </div>
        <div className="brnd text-center mt-3 ">
          <div className='imagi mt-3 bg-white '>
            <img src={img101} width={1200} height={300} alt='Queryimg' />
          </div>
          <div className="row">
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img26} width={100} height={100} alt='Queryimg' />
              <p><b>Ali Baba Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img27} width={100} height={100} alt='Queryimg' />
              <p><b>Etsy Account Management<br /> Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img28} width={100} height={100} alt='Queryimg' />
              <p><b>Walmart Account Management Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>
            <div className="col-sm bg-white text-dark border border-dark border-5 py-3">
              <img src={img29} width={100} height={100} alt='Queryimg' />
              <p><b>Ebay Account Management <br />Services</b><br />
                <button type="button" className="btn "><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  Learn More
                </Link></button>
              </p>
            </div>

          </div>
          <div className='py-3 mt-3 bg-white'>
            <img src={img30} alt='Queryimg' />
          </div>
        </div>

      </div>

    </div>
  )
}
